import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";

export default function ConsignorsPage() {
  const [consignors, setConsignors] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    (async () => {
      const [c, s] = await Promise.all([api.get("/consignors"), api.get("/site-settings")]);
      setConsignors(c.data);
      setSettings(s.data);
    })();
  }, []);

  return (
    <div data-testid="consignors-page" className="min-h-screen" style={{ background: "var(--bg-primary)" }}>
      <SiteHeader />
      <section className="pt-40 pb-12 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="eyebrow">Meet the Consignors</div>
          <h1 className="font-display text-6xl md:text-8xl lg:text-9xl mt-4 leading-[0.95]">
            Eight ranches.<br />One catalog.
          </h1>
          <p className="mt-8 max-w-2xl text-base md:text-lg" style={{ color: "var(--text-secondary)" }}>
            The Bulls of the Big Sky consignors offer the best of both worlds. They are uniquely
            situated to offer an extremely consistent set of bulls, while also offering the unique
            breeding perspectives of each individual consignor. Together they raise the genetic
            standard to deliver a set of bulls that will excel in any operation.
          </p>
        </div>
      </section>

      <section className="px-6 md:px-12 pb-32">
        <div className="max-w-[1400px] mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-8">
          {consignors.map((c, i) => {
            const card = (
              <>
                <div
                  className="relative overflow-hidden border transition-colors duration-300"
                  style={{ aspectRatio: "4 / 3", background: "var(--bg-secondary)", borderColor: "var(--border-subtle)" }}
                >
                  {c.family_photo_url ? (
                    <img
                      src={c.family_photo_url}
                      alt={c.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                      style={{ objectPosition: "center top" }}
                    />
                  ) : c.image_url ? (
                    <div className="w-full h-full flex items-center justify-center">
                      <img
                        src={c.image_url}
                        alt={c.name}
                        className="max-w-[70%] max-h-[60%] object-contain transition-transform duration-500 group-hover:scale-[1.03]"
                      />
                    </div>
                  ) : (
                    <div className="w-full h-full flex items-center justify-center font-display text-2xl md:text-3xl text-center px-4" style={{ color: "var(--text-primary)" }}>
                      {c.name}
                    </div>
                  )}
                </div>
                <div
                  className="mt-4 font-display text-base md:text-lg text-center tracking-wide"
                  style={{ color: "var(--text-secondary)" }}
                >
                  {c.name}
                  {c.location && (
                    <div className="eyebrow-muted text-[10px] mt-1 normal-case" style={{ color: "var(--brass)", letterSpacing: "0.18em" }}>
                      {c.location.split("•").map((part) => (
                        <div key={part.trim()}>{part.trim()}</div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            );
            return c.slug ? (
              <Link key={c.id} to={`/consignor/${c.slug}`} data-testid={`consignor-${i}`} className="consignor-card group block">
                {card}
              </Link>
            ) : (
              <div key={c.id} data-testid={`consignor-${i}`} className="consignor-card group block">{card}</div>
            );
          })}
        </div>
      </section>

      <SiteFooter settings={settings} />
    </div>
  );
}
